/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Team_Summary_CountInputs */



/**
* | output |
* | --- |
* | "You have 1:1s with {count} colleagues." |
*
* @param {Team_Summary_CountInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const team_summary_count = /** @type {((inputs: Team_Summary_CountInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Summary_CountInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`Je hebt 1:1's met ${i?.count} collega's.`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`Vous avez des one-to-ones avec ${i?.count} collègues.`)
	return /** @type {LocalizedString} */ (`You have 1:1s with ${i?.count} colleagues.`)
});